module.exports = __webpack_public_path__ + "static/media/cover.b25f791f.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cover.mp4
 ** module id = 486
 ** module chunks = 0
 **/